import React from "react";
import { Flex } from "antd";
import CustomLoader from "../../../../common/UI/Loader";

const ProductLoader: React.FC = () => (
  <Flex className="pd-loader" justify="center" align="center">
    <CustomLoader />
  </Flex>
);

export default ProductLoader;
